export default __webpack_public_path__ + "static/media/time.6c80e23f.svg";